import SVG from 'Components/SVG';

interface ButtonProps {
  label: string;
  onClick: () => void;

  type?: 'button' | 'submit' | 'reset';
  className?: string;
  svg_type?: string;
  iconClass?: string;
  disabled?: boolean;
  iconOnLeft?: boolean;
  stroke?: boolean;
  round?: boolean;
  cancel?: boolean;
}

function Button({ label, onClick, className, svg_type, iconClass, disabled, iconOnLeft, stroke, type = 'button', round, cancel }: ButtonProps) {
  return (
    <button
      type={type}
      className={`btn ${className ? className : ''} ${round ? 'btn--round' : ''} ${cancel ? 'btn--cancel' : ''} ${disabled ? 'btn--disabled' : ''} ${
        stroke ? 'btn--stroke' : ''
      }`}
      onClick={onClick}>
      {iconOnLeft && svg_type ? <SVG type={svg_type} className={iconClass} /> : null}
      {label}
      {!iconOnLeft && svg_type ? <SVG type={svg_type} className={iconClass} /> : null}
    </button>
  );
}

export default Button;
